import { render, staticRenderFns } from "./SelectBoxType.vue?vue&type=template&id=096ecdcc&scoped=true&"
import script from "./SelectBoxType.vue?vue&type=script&lang=js&"
export * from "./SelectBoxType.vue?vue&type=script&lang=js&"
import style0 from "./SelectBoxType.vue?vue&type=style&index=0&id=096ecdcc&lang=scss&scoped=true&"
import style1 from "./SelectBoxType.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096ecdcc",
  null
  
)

export default component.exports